// extracted by mini-css-extract-plugin
export default {"image-actions":"styles_image-actions__ej+1w"};